module.exports = __webpack_public_path__ + "static/media/Group 1509@3x.cc55b827.png";